import { render, staticRenderFns } from "./CreditCardPaymentComponentSaferpay.vue?vue&type=template&id=122facfe"
import script from "./CreditCardPaymentComponentSaferpay.vue?vue&type=script&lang=js"
export * from "./CreditCardPaymentComponentSaferpay.vue?vue&type=script&lang=js"
import style0 from "./CreditCardPaymentComponentSaferpay.vue?vue&type=style&index=0&id=122facfe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports